<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiPlaylistEdit } from "@mdi/js";
export default {
  name: "MdiPlaylistEdit",
  data() {
    return {
      svgPath: mdiPlaylistEdit,
    };
  },
};
</script>
